import TownBuyerLandingPage from "./TownBuyerLandingPage";
const MountLaurelLanding = () => (
  <TownBuyerLandingPage townName="Mount Laurel" slug="homes-for-sale-mount-laurel" savedLinkId="10351" viewAllUrl="https://homes.prpsj.com/i/homes-for-sale-mount-laurel-ac" />
);
export default MountLaurelLanding;
